import ProfilePassword from '@/components/profile/password';

export default ProfilePassword;
